// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/demo-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/frame-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Images/trangle.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1,
h2,
h3,
h4,
h5,
h6,
label,
ul,
ol {
  margin: 0;
  padding: 0;
  list-style: none;
  color: #000;
}
body {
  background-color: #cae1c9;
}
.top-nav .navbar-brand img {
  width: 60px;
}
.top-nav .nav-link {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 50px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: #d0ff00;
  border-radius: 25px;
  padding: 0 30px !important;
  height: 50px;
}
.top-nav .navbar-brand {
  margin: 0 60px 0 0;
}
.top-nav .nav-ul li a {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 50px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: #d0ff00;
  border-radius: 25px;
  padding: 0 30px !important;
  height: 50px;
  text-decoration: none;
  color: #000;
  display: block;
}
.top-nav .areax-img {
  height: 18px;
  width: auto;
  margin: 0 0 0 30px;
}
.top-nav .d-flex.form-cus-nav {
  align-items: center;
}

.top-nav {
  background: #cae1c9;
}
.top-nav nav.navbar.navbar-expand-lg.bg-body-tertiary {
  background: transparent !important;
  padding: 80px 0 0px 0;
}
.container {
  max-width: 1250px !important;
}
.project-img {
  width: 100%;
}
.right-project {
  padding: 0 25px 0 0;
}
.creative-reel {
  width: 100%;
  position: relative;
  bottom: 70px;
}
.project-p-1 {
  font-family: Poppins;
  font-size: 64px;
  font-weight: 600;
  line-height: 67px;
  letter-spacing: -1px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0 0 15px 0;
  color: #000;
}
.project-p-2 {
  font-family: Poppins;
  font-size: 25px;
  font-weight: 600;
  line-height: 37.5px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0 0 15px 0;
}
.sounds-ul li p {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 600;
  line-height: 67px;
  letter-spacing: -1px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.sounds-ul li a {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 71px;
  letter-spacing: -1px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #000;
  text-decoration: none;
  border: 1px solid #000000;
  background: #d0ff00;
  margin: 0 0px 0 0;
  padding: 0 15px;
  border-radius: 50px;
  height: 79px;
  display: inline-block;
  min-width: 79px;
}
.sounds-ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.PROJECTW {
  background-color: #cae1c9;
  padding: 120px 0 22px 0;
  border-bottom-left-radius: 194px;
  border-bottom-right-radius: 194px;
  position: relative;
}
.row.cus-row {
  align-items: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 900px;
  border-bottom-left-radius: 100px;
  border-bottom-right-radius: 100px;
}
.yellow-sec {
  background: #d0ff00;
  padding: 260px 0 54px 0;
  margin-top: -194px;
}
.yellow-p {
  font-family: Poppins;
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  letter-spacing: -1px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0 0 60px 0;
}
.yellow-p b {
  font-weight: 700;
}
.yellow-2 {
  background: #cae1c9;
  padding: 45px 0;
}
.under-flex li a {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  display: block;
  text-decoration: none;
  color: #000;
  border: 1px solid #000000;
  background: #d0ff00;
  padding: 0 30px;
  height: 79px;
  line-height: 79px;
  text-align: center;
  border-radius: 39px;
  min-width: 325px;
}
.under-flex ul li p {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 600;
  line-height: 37.5px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0 0 0px 0;
  max-width: 740px;
}
.under-flex ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.right-side-img {
  display: flex;
  justify-content: flex-end;
  padding: 0 80px 0 0;
}
.phone-14-class {
  width: 100%;
  max-width: 1060px;
}
.instant {
  background-color: #cae1c9;
  padding: 60px 0;
}
.vec-p {
  font-family: Poppins;
  font-size: 64px;
  font-weight: 600;
  line-height: 67px;
  letter-spacing: -1px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
}
.instant-ul li {
  display: flex;
  align-items: flex-start;
  margin: 0 0 30px 0;
}
.vec-img {
  width: 55px;
  margin: 0 15px 0 0;
  position: relative;
  top: 10px;
}
.vec-p-1 {
  font-family: Poppins;
  font-size: 40px;
  font-weight: 600;
  line-height: 37.83px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  padding: 0 0 0 70px;
}
.background-img-sec {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.join {
  background: #d0ff00;
  padding: 60px 0;
}
.join-p {
  font-family: Poppins;
  font-size: 40px;
  font-weight: 600;
  line-height: 37.83px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.join-under ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.join-under .mc4wp-form-fields {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  list-style: none;
}
#form-response p {
  margin: 0;
  padding: 10px;
}
#form-response p {
  font-weight: bold;
}

.input-join {
  border: 1px solid #000000;
  height: 79px;
  padding: 0 30px;
  border-radius: 40px;
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 28.37px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #000;
  max-width: 383px;
  background: transparent;
}
.subscribe-bt {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 28.37px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: #cae1c9;
  border: 1px solid #000000;
  height: 79px;
  padding: 0 30px;
  border-radius: 40px;
  min-width: 248px;
}
.logo-section {
  background: #d0ff00;
  padding: 0 0 90px 0;
}
.height-30 {
  background-color: #cae1c9;
  height: 54px;
  width: 100%;
}
.logo-under ul li img {
  max-height: 63px;
  width: auto;
}
.logo-under ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.logo-under ul li {
  width: 25%;
  display: flex;
  justify-content: center;
  margin: 70px 0 0 0;
}
.logo-under {
  padding: 40px 0 0 0;
}
.contact-footer {
  font-family: Poppins;
  font-size: 60px;
  font-weight: 600;
  line-height: 69px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0 0 50px 0;
}
.footer-label {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  line-height: 28.75px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  display: block;
  padding: 0 0 0 7px;
  margin: 0 0 0px 0;
}
.footer-input {
  font-family: Poppins;
  font-size: 25px;
  font-weight: 500;
  line-height: 28.75px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  border: none;
  border-bottom: 1px solid #000;
  padding: 15px 7px;
  background: transparent;
  width: 100%;
}
.footer-ul-1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer-input.wid-1 {
  /* max-width: 257px; */
  max-width: 200px;
}
.footer-input.wid-2 {
  /* max-width: 377px; */
  max-width: 310px;
}
.footer-input.wid-3 {
  /* max-width: 174px; */
  max-width: 200px;
}
.footer-input.wid-4 {
  /* max-width: 236px; */
  max-width: 220px;
}
.footer-section {
  background-color: #cae1c9;
  padding: 60px 0 0 0;
}
.footer-ul-2 li button {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 34.5px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  height: 85px;
  background: #d0ff00;
  padding: 0 30px;
  border-radius: 42px;
  min-width: 255px;
  text-align: center;
  border: 1px solid #000;
}
.footer-ul-2 li button img {
  width: 25px;
  margin: 0px 0 0 15px;
}
.footer-ul-2 {
  display: flex;
  justify-content: space-between;
  margin: 60px 0 0 0;
  flex-wrap: wrap;
}
.info-a {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 34.5px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-decoration: none;
  color: #000;
}
.footer-ul-3 li a {
  font-family: Poppins;
  font-size: 25px;
  font-weight: 500;
  line-height: 28.75px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #000;
  text-decoration: none;
}
.footer-ul-3 {
  display: flex;
  align-items: center;
  margin: 0 0 0 100px;
  flex-wrap: wrap;
}
.footer-last {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 50px 0 60px 0;
}
.footer-ul-3 li a {
  margin: 0 40px 0 0;
}
.footer-ul-2 li:nth-child(1) {
  width: 100%;
  max-width: 915px;
}
.height-54 {
  background-color: #d0ff00;
  height: 54px;
  width: 100%;
  display: flex;
}
.footer-input::placeholder {
  color: #97a997;
}
.input-join::placeholder {
  color: #b1d900;
}
.input-join::-ms-input-placeholder {
  color: #b1d900;
}
.zoom {
  transition: transform 0.2s;
}
.zoom:hover {
  transform: scale(1.12);
}
.zooms {
  position: relative;
  padding-right: 40px; /* Adjust space to fit the image */
  font-size: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.zooms::after {
  content: "";
  position: absolute;
  right: 10px; /* Adjust the distance from the button's edge */
  top: 50%;
  transform: translateY(-50%);
  width: 16px; /* Set the width of the image */
  height: 16px; /* Set the height of the image */
  background-image: url("https://projectw.ai/wp-content/uploads/2025/01/up-right-arrow.png"); /* Replace with your image URL */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.footer-input:focus {
  outline: none;
  box-shadow: none;
}
.footer-ul-3 li a {
  position: relative;
  transition: 0.5s;
}
.footer-ul-3 li a:after {
  position: absolute;
  left: 0;
  bottom: -6px;
  height: 3px;
  background: #000000;
  content: "";
  width: 0;
  transition: 0.5s;
}
.footer-ul-3 li a:hover:after {
  width: 100%;
}
.input-join:focus {
  outline: none;
  box-shadow: none;
}
.footer-ul-1 li {
  position: relative;
}
.footer-ul-1 li:nth-child(3):after {
  position: absolute;
  right: -55px;
  bottom: -10px;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 40px;
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
}

.creative-reel {
  animation: mover 1s infinite alternate;
}
.creative-reel {
  animation: mover 1s infinite alternate;
}
@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}
.phone-14-class {
  animation: mover 1s infinite alternate;
}
@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}
.top-nav .navbar-toggler {
  background: #d0ff00;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #d0ff00;
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.3);
}
.project-p-size {
  font-family: Poppins;
  font-size: 213px;
  font-weight: 600;
  line-height: 173px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-align: left;
  position: relative;
  right: 15px;
}
.logo-under ul li:last-child {
  position: relative;
  bottom: 10px;
}
.logo-under ul li:nth-child(5) {
  position: relative;
  bottom: 10px;
}
.logo-under ul li:nth-child(3) {
  position: relative;
  bottom: 10px;
}

.post-113.page.type-page.status-publish.hentry {
  padding: 50px 0px 50px 0px !important;
}
.post-115.page.type-page.status-publish.hentry {
  padding: 50px 0px 50px 0px !important;
}
.entry-title {
  font-family: Poppins;
  font-size: 60px;
  font-weight: 600;
  line-height: 69px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0 0 50px 0;
}
.entry-content h1 {
  font-family: Poppins;
  font-size: 40px !important;
  font-weight: 500;
  line-height: 69px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 20px 0 20px 0;
}
.entry-content h2 strong {
  font-family: Poppins;
  font-size: 40px !important;
  font-weight: 500;
  line-height: 69px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 20px 0 20px 0;
}
.entry-content h2 {
  font-family: Poppins;
  font-size: 40px !important;
  font-weight: 500;
  line-height: 69px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 20px 0 20px 0;
}
.entry-content p {
  font-family: Poppins;
  font-size: 16px !important;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.entry-content ul li {
  list-style: disc;
}
.entry-content ul li::marker {
  color: #000;
}
.entry-content ul {
  padding-left: 0px;
  margin-left: 20px;
}

.wpcf7-select {
  font-family: Poppins;
  font-size: 25px;
  font-weight: 500;
  line-height: 28.75px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  border: none;
  border-bottom: 1px solid #000;
  padding: 15px 7px;
  width: 100%;
  appearance: none;
  box-sizing: border-box;
  cursor: pointer;
  color: #99ab99;
  background: #cae1c9;
}
.wpcf7-select option:hover {
  background-color: #99ab99 !important;
  color: #fff !important;
}
textarea.wpcf7-form-control.wpcf7-textarea.wpcf7-validates-as-required.footer-input.wid-5 {
  height: 60px;
}
ul.footer-ul-2 li:last-child p input {
  font-family: Poppins;
  font-size: 30px;
  font-weight: 500;
  line-height: 34.5px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  height: 85px;
  background: #d0ff00;
  padding: 0 30px;
  border-radius: 42px;
  min-width: 255px;
  text-align: start;
  border: 1px solid #000;
  display: inline-block;
  vertical-align: middle;
}
ul.footer-ul-2 li:last-child p {
  display: inline-block;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 250px;
  position: relative;
}
ul#menu-bottom-line li a {
  font-size: 20px;
  font-family: "Poppins";
}
span.wpcf7-spinner {
  display: none;
}
img.up-arrow {
  width: 100%;
  max-width: 25px;
  position: absolute;
  z-index: 9;
  top: 31px;
  right: 20px;
  transform: translate(0px, -1px);
}
@media (max-width: 1250px) {
  .project-p-size {
    font-size: 165px;
  }
}

@media (max-width: 1024px) {
  .container {
    padding-left: 30px;
    padding-right: 30px;
  }
  .yellow-p br {
    display: none;
  }
  .PROJECTW {
    border-bottom-left-radius: 94px;
    border-bottom-right-radius: 94px;
  }
  .footer-input {
    font-size: 16px;
    max-width: 100% !important;
    padding: 2px 8px;
  }
  .footer-ul-1 li {
    width: 19%;
  }
  .footer-ul-2 li:nth-child(1) {
    max-width: max-content;
  }
  .join-under li:nth-child(1) {
    width: 100%;
    margin: 0 0 30px 0;
  }
  .join-under li:nth-child(2) {
    width: 55%;
  }
  .join-under li:nth-child(3) {
    width: 40%;
  }
  .input-join {
    max-width: 100%;
    width: 100%;
  }
  .subscribe-bt {
    width: 100%;
  }
}

@media (max-width: 1008px) {
  .project-p-size {
    font-size: 115px;
    text-align: left;
    right: 0;
  }
}

@media (max-width: 991px) {
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }
  .footer-ul-1 li {
    width: 45%;
    margin: 0 0 50px 0;
  }
  .footer-ul-2 {
    margin: 0px 0 0 0;
  }
  .footer-ul-2 li:nth-child(1) {
    max-width: 45%;
  }
  .logo-under ul li img {
    max-height: 50px;
  }
  .project-img {
    margin: 0 0 30px 0;
  }
  .creative-reel {
    bottom: -60px;
  }
  .top-nav .navbar-nav.me-auto.mb-2.mb-lg-0 {
    max-width: 300px;
    margin: 30px auto 30px auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .nav-ul {
    flex-wrap: wrap;
    display: flex;
    width: 100%;
  }
  .nav-ul li {
    width: 100%;
    margin: 0 0 15px 0;
  }
  .top-nav .d-flex.form-cus-nav {
    flex-wrap: wrap;
    max-width: 300px;
    margin: auto;
  }
  .top-nav .areax-img {
    margin: auto;
  }
  .right-side-img {
    padding: 0;
  }
  .right-project {
    padding: 0 0px 0 0;
  }
}

@media (max-width: 767px) {
  .project-p-1,
  .yellow-p,
  .vec-p,
  .join-p,
  .contact-footer {
    font-size: 23px;
    line-height: 38px;
  }
  .project-p-2,
  .under-flex ul li p,
  .vec-p-1 {
    font-size: 16px;
    line-height: 26.5px;
  }
  .under-flex ul {
    flex-wrap: wrap;
  }
  .under-flex ul li p {
    margin: 0 0 15px 0;
  }
  .join-under li:nth-child(2) {
    width: 100%;
    margin: 0 0 15px 0;
  }
  .join-under li:nth-child(3) {
    width: 100%;
  }
  .logo-under ul li img {
    max-height: fit-content;
    width: 100%;
    height: auto;
  }
  .logo-under ul li {
    width: 28%;
    margin: 20px 0 0 0;
  }
  .footer-ul-1 li {
    width: 100%;
    margin: 0 0 30px 0;
  }
  .footer-ul-1 li:nth-child(3):after {
    display: none;
  }
  .footer-label {
    margin: 0 0 0px 0;
  }
  .footer-ul-2 li:nth-child(1) {
    max-width: 100%;
    margin: 0 0 30px 0;
  }
  .footer-ul-2 li {
    width: 100%;
  }
  .footer-ul-2 li button {
    width: 100%;
  }
  .footer-ul-3 {
    margin: 15px 0 0 0;
  }
  .footer-ul-3 li a {
    margin: 0 15px 0 0;
    font-size: 18px;
    line-height: 28.75px;
  }
  .top-nav nav.navbar.navbar-expand-lg.bg-body-tertiary {
    padding: 30px 0 0px 0;
  }
  .PROJECTW {
    padding: 30px 0 22px 0;
  }
  .logo-section {
    padding: 0 0 40px 0;
  }
  .logo-under {
    padding: 20px 0 0 0;
  }
  .project-p-size {
    font-size: 30px;
    line-height: normal;
  }
  .logo-under ul li:last-child {
    bottom: 5px;
  }
}

html {
  scroll-behavior: smooth;
}
`, "",{"version":3,"sources":["webpack://./src/Css/custom-style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mDAAyC;EACzC,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,mDAAsC;EACtC,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,aAAa;AACf;AACA;EACE,cAAc;AAChB;AAIA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,kCAAkC;EACvD,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW,EAAE,+CAA+C;EAC5D,QAAQ;EACR,2BAA2B;EAC3B,WAAW,EAAE,+BAA+B;EAC5C,YAAY,EAAE,gCAAgC;EAC9C,0FAA0F,EAAE,gCAAgC;EAC5H,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,mDAAsC;EACtC,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EAEE,sCAAsC;AACxC;AACA;EAEE,sCAAsC;AACxC;AASA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EAEE,sCAAsC;AACxC;AASA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,oDAAoD;EAEpD,mBAAmB;AACrB;AACA;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,+BAA+B;AACjC;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,eAAe;IACf,aAAa;IACb,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;IAKE,eAAe;IACf,iBAAiB;EACnB;EACA;;;IAGE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["p,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nlabel,\nul,\nol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  color: #000;\n}\nbody {\n  background-color: #cae1c9;\n}\n.top-nav .navbar-brand img {\n  width: 60px;\n}\n.top-nav .nav-link {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 50px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  background: #d0ff00;\n  border-radius: 25px;\n  padding: 0 30px !important;\n  height: 50px;\n}\n.top-nav .navbar-brand {\n  margin: 0 60px 0 0;\n}\n.top-nav .nav-ul li a {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 50px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  background: #d0ff00;\n  border-radius: 25px;\n  padding: 0 30px !important;\n  height: 50px;\n  text-decoration: none;\n  color: #000;\n  display: block;\n}\n.top-nav .areax-img {\n  height: 18px;\n  width: auto;\n  margin: 0 0 0 30px;\n}\n.top-nav .d-flex.form-cus-nav {\n  align-items: center;\n}\n\n.top-nav {\n  background: #cae1c9;\n}\n.top-nav nav.navbar.navbar-expand-lg.bg-body-tertiary {\n  background: transparent !important;\n  padding: 80px 0 0px 0;\n}\n.container {\n  max-width: 1250px !important;\n}\n.project-img {\n  width: 100%;\n}\n.right-project {\n  padding: 0 25px 0 0;\n}\n.creative-reel {\n  width: 100%;\n  position: relative;\n  bottom: 70px;\n}\n.project-p-1 {\n  font-family: Poppins;\n  font-size: 64px;\n  font-weight: 600;\n  line-height: 67px;\n  letter-spacing: -1px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0 0 15px 0;\n  color: #000;\n}\n.project-p-2 {\n  font-family: Poppins;\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 37.5px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0 0 15px 0;\n}\n.sounds-ul li p {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 600;\n  line-height: 67px;\n  letter-spacing: -1px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n.sounds-ul li a {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 71px;\n  letter-spacing: -1px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: #000;\n  text-decoration: none;\n  border: 1px solid #000000;\n  background: #d0ff00;\n  margin: 0 0px 0 0;\n  padding: 0 15px;\n  border-radius: 50px;\n  height: 79px;\n  display: inline-block;\n  min-width: 79px;\n}\n.sounds-ul {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.PROJECTW {\n  background-color: #cae1c9;\n  padding: 120px 0 22px 0;\n  border-bottom-left-radius: 194px;\n  border-bottom-right-radius: 194px;\n  position: relative;\n}\n.row.cus-row {\n  align-items: center;\n  background: url(../Images/demo-image.png);\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  min-height: 900px;\n  border-bottom-left-radius: 100px;\n  border-bottom-right-radius: 100px;\n}\n.yellow-sec {\n  background: #d0ff00;\n  padding: 260px 0 54px 0;\n  margin-top: -194px;\n}\n.yellow-p {\n  font-family: Poppins;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 56px;\n  letter-spacing: -1px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0 0 60px 0;\n}\n.yellow-p b {\n  font-weight: 700;\n}\n.yellow-2 {\n  background: #cae1c9;\n  padding: 45px 0;\n}\n.under-flex li a {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  display: block;\n  text-decoration: none;\n  color: #000;\n  border: 1px solid #000000;\n  background: #d0ff00;\n  padding: 0 30px;\n  height: 79px;\n  line-height: 79px;\n  text-align: center;\n  border-radius: 39px;\n  min-width: 325px;\n}\n.under-flex ul li p {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 600;\n  line-height: 37.5px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0 0 0px 0;\n  max-width: 740px;\n}\n.under-flex ul {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.right-side-img {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 80px 0 0;\n}\n.phone-14-class {\n  width: 100%;\n  max-width: 1060px;\n}\n.instant {\n  background-color: #cae1c9;\n  padding: 60px 0;\n}\n.vec-p {\n  font-family: Poppins;\n  font-size: 64px;\n  font-weight: 600;\n  line-height: 67px;\n  letter-spacing: -1px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0;\n}\n.instant-ul li {\n  display: flex;\n  align-items: flex-start;\n  margin: 0 0 30px 0;\n}\n.vec-img {\n  width: 55px;\n  margin: 0 15px 0 0;\n  position: relative;\n  top: 10px;\n}\n.vec-p-1 {\n  font-family: Poppins;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 37.83px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  padding: 0 0 0 70px;\n}\n.background-img-sec {\n  background: url(../Images/frame-1.png);\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.join {\n  background: #d0ff00;\n  padding: 60px 0;\n}\n.join-p {\n  font-family: Poppins;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 37.83px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n.join-under ul {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.join-under .mc4wp-form-fields {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  list-style: none;\n}\n#form-response p {\n  margin: 0;\n  padding: 10px;\n}\n#form-response p {\n  font-weight: bold;\n}\n\n.input-join {\n  border: 1px solid #000000;\n  height: 79px;\n  padding: 0 30px;\n  border-radius: 40px;\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 28.37px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: #000;\n  max-width: 383px;\n  background: transparent;\n}\n.subscribe-bt {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 28.37px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  background: #cae1c9;\n  border: 1px solid #000000;\n  height: 79px;\n  padding: 0 30px;\n  border-radius: 40px;\n  min-width: 248px;\n}\n.logo-section {\n  background: #d0ff00;\n  padding: 0 0 90px 0;\n}\n.height-30 {\n  background-color: #cae1c9;\n  height: 54px;\n  width: 100%;\n}\n.logo-under ul li img {\n  max-height: 63px;\n  width: auto;\n}\n.logo-under ul {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.logo-under ul li {\n  width: 25%;\n  display: flex;\n  justify-content: center;\n  margin: 70px 0 0 0;\n}\n.logo-under {\n  padding: 40px 0 0 0;\n}\n.contact-footer {\n  font-family: Poppins;\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 69px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0 0 50px 0;\n}\n.footer-label {\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 28.75px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  display: block;\n  padding: 0 0 0 7px;\n  margin: 0 0 0px 0;\n}\n.footer-input {\n  font-family: Poppins;\n  font-size: 25px;\n  font-weight: 500;\n  line-height: 28.75px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  border: none;\n  border-bottom: 1px solid #000;\n  padding: 15px 7px;\n  background: transparent;\n  width: 100%;\n}\n.footer-ul-1 {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.footer-input.wid-1 {\n  /* max-width: 257px; */\n  max-width: 200px;\n}\n.footer-input.wid-2 {\n  /* max-width: 377px; */\n  max-width: 310px;\n}\n.footer-input.wid-3 {\n  /* max-width: 174px; */\n  max-width: 200px;\n}\n.footer-input.wid-4 {\n  /* max-width: 236px; */\n  max-width: 220px;\n}\n.footer-section {\n  background-color: #cae1c9;\n  padding: 60px 0 0 0;\n}\n.footer-ul-2 li button {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 34.5px;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  height: 85px;\n  background: #d0ff00;\n  padding: 0 30px;\n  border-radius: 42px;\n  min-width: 255px;\n  text-align: center;\n  border: 1px solid #000;\n}\n.footer-ul-2 li button img {\n  width: 25px;\n  margin: 0px 0 0 15px;\n}\n.footer-ul-2 {\n  display: flex;\n  justify-content: space-between;\n  margin: 60px 0 0 0;\n  flex-wrap: wrap;\n}\n.info-a {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 34.5px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  text-decoration: none;\n  color: #000;\n}\n.footer-ul-3 li a {\n  font-family: Poppins;\n  font-size: 25px;\n  font-weight: 500;\n  line-height: 28.75px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: #000;\n  text-decoration: none;\n}\n.footer-ul-3 {\n  display: flex;\n  align-items: center;\n  margin: 0 0 0 100px;\n  flex-wrap: wrap;\n}\n.footer-last {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin: 50px 0 60px 0;\n}\n.footer-ul-3 li a {\n  margin: 0 40px 0 0;\n}\n.footer-ul-2 li:nth-child(1) {\n  width: 100%;\n  max-width: 915px;\n}\n.height-54 {\n  background-color: #d0ff00;\n  height: 54px;\n  width: 100%;\n  display: flex;\n}\n.footer-input::placeholder {\n  color: #97a997;\n}\n.footer-input::-ms-input-placeholder {\n  color: #97a997;\n}\n.input-join::placeholder {\n  color: #b1d900;\n}\n.input-join::-ms-input-placeholder {\n  color: #b1d900;\n}\n.zoom {\n  transition: transform 0.2s;\n}\n.zoom:hover {\n  transform: scale(1.12);\n}\n.zooms {\n  position: relative;\n  padding-right: 40px; /* Adjust space to fit the image */\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.zooms::after {\n  content: \"\";\n  position: absolute;\n  right: 10px; /* Adjust the distance from the button's edge */\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px; /* Set the width of the image */\n  height: 16px; /* Set the height of the image */\n  background-image: url(\"https://projectw.ai/wp-content/uploads/2025/01/up-right-arrow.png\"); /* Replace with your image URL */\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.footer-input:focus {\n  outline: none;\n  box-shadow: none;\n}\n.footer-ul-3 li a {\n  position: relative;\n  transition: 0.5s;\n}\n.footer-ul-3 li a:after {\n  position: absolute;\n  left: 0;\n  bottom: -6px;\n  height: 3px;\n  background: #000000;\n  content: \"\";\n  width: 0;\n  transition: 0.5s;\n}\n.footer-ul-3 li a:hover:after {\n  width: 100%;\n}\n.input-join:focus {\n  outline: none;\n  box-shadow: none;\n}\n.footer-ul-1 li {\n  position: relative;\n}\n.footer-ul-1 li:nth-child(3):after {\n  position: absolute;\n  right: -55px;\n  bottom: -10px;\n  content: \"\";\n  background: url(../Images/trangle.png);\n  background-size: 40px;\n  width: 40px;\n  height: 40px;\n  background-repeat: no-repeat;\n}\n\n.creative-reel {\n  -webkit-animation: mover 1s infinite alternate;\n  animation: mover 1s infinite alternate;\n}\n.creative-reel {\n  -webkit-animation: mover 1s infinite alternate;\n  animation: mover 1s infinite alternate;\n}\n@-webkit-keyframes mover {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n@keyframes mover {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n.phone-14-class {\n  -webkit-animation: mover 1s infinite alternate;\n  animation: mover 1s infinite alternate;\n}\n@-webkit-keyframes mover {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n@keyframes mover {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n.top-nav .navbar-toggler {\n  background: #d0ff00;\n}\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: #d0ff00;\n}\n::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(255, 255, 255, 0.3);\n}\n.project-p-size {\n  font-family: Poppins;\n  font-size: 213px;\n  font-weight: 600;\n  line-height: 173px;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  text-align: left;\n  position: relative;\n  right: 15px;\n}\n.logo-under ul li:last-child {\n  position: relative;\n  bottom: 10px;\n}\n.logo-under ul li:nth-child(5) {\n  position: relative;\n  bottom: 10px;\n}\n.logo-under ul li:nth-child(3) {\n  position: relative;\n  bottom: 10px;\n}\n\n.post-113.page.type-page.status-publish.hentry {\n  padding: 50px 0px 50px 0px !important;\n}\n.post-115.page.type-page.status-publish.hentry {\n  padding: 50px 0px 50px 0px !important;\n}\n.entry-title {\n  font-family: Poppins;\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 69px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 0 0 50px 0;\n}\n.entry-content h1 {\n  font-family: Poppins;\n  font-size: 40px !important;\n  font-weight: 500;\n  line-height: 69px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 20px 0 20px 0;\n}\n.entry-content h2 strong {\n  font-family: Poppins;\n  font-size: 40px !important;\n  font-weight: 500;\n  line-height: 69px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 20px 0 20px 0;\n}\n.entry-content h2 {\n  font-family: Poppins;\n  font-size: 40px !important;\n  font-weight: 500;\n  line-height: 69px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  margin: 20px 0 20px 0;\n}\n.entry-content p {\n  font-family: Poppins;\n  font-size: 16px !important;\n  font-weight: 400;\n  line-height: 30px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n.entry-content ul li {\n  list-style: disc;\n}\n.entry-content ul li::marker {\n  color: #000;\n}\n.entry-content ul {\n  padding-left: 0px;\n  margin-left: 20px;\n}\n\n.wpcf7-select {\n  font-family: Poppins;\n  font-size: 25px;\n  font-weight: 500;\n  line-height: 28.75px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  border: none;\n  border-bottom: 1px solid #000;\n  padding: 15px 7px;\n  width: 100%;\n  appearance: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  color: #99ab99;\n  background: #cae1c9;\n}\n.wpcf7-select option:hover {\n  background-color: #99ab99 !important;\n  color: #fff !important;\n}\ntextarea.wpcf7-form-control.wpcf7-textarea.wpcf7-validates-as-required.footer-input.wid-5 {\n  height: 60px;\n}\nul.footer-ul-2 li:last-child p input {\n  font-family: Poppins;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 34.5px;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  height: 85px;\n  background: #d0ff00;\n  padding: 0 30px;\n  border-radius: 42px;\n  min-width: 255px;\n  text-align: start;\n  border: 1px solid #000;\n  display: inline-block;\n  vertical-align: middle;\n}\nul.footer-ul-2 li:last-child p {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-width: 250px;\n  position: relative;\n}\nul#menu-bottom-line li a {\n  font-size: 20px;\n  font-family: \"Poppins\";\n}\nspan.wpcf7-spinner {\n  display: none;\n}\nimg.up-arrow {\n  width: 100%;\n  max-width: 25px;\n  position: absolute;\n  z-index: 9;\n  top: 31px;\n  right: 20px;\n  transform: translate(0px, -1px);\n}\n@media (max-width: 1250px) {\n  .project-p-size {\n    font-size: 165px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .container {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .yellow-p br {\n    display: none;\n  }\n  .PROJECTW {\n    border-bottom-left-radius: 94px;\n    border-bottom-right-radius: 94px;\n  }\n  .footer-input {\n    font-size: 16px;\n    max-width: 100% !important;\n    padding: 2px 8px;\n  }\n  .footer-ul-1 li {\n    width: 19%;\n  }\n  .footer-ul-2 li:nth-child(1) {\n    max-width: max-content;\n  }\n  .join-under li:nth-child(1) {\n    width: 100%;\n    margin: 0 0 30px 0;\n  }\n  .join-under li:nth-child(2) {\n    width: 55%;\n  }\n  .join-under li:nth-child(3) {\n    width: 40%;\n  }\n  .input-join {\n    max-width: 100%;\n    width: 100%;\n  }\n  .subscribe-bt {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1008px) {\n  .project-p-size {\n    font-size: 115px;\n    text-align: left;\n    right: 0;\n  }\n}\n\n@media (max-width: 991px) {\n  .container {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .footer-ul-1 li {\n    width: 45%;\n    margin: 0 0 50px 0;\n  }\n  .footer-ul-2 {\n    margin: 0px 0 0 0;\n  }\n  .footer-ul-2 li:nth-child(1) {\n    max-width: 45%;\n  }\n  .logo-under ul li img {\n    max-height: 50px;\n  }\n  .project-img {\n    margin: 0 0 30px 0;\n  }\n  .creative-reel {\n    bottom: -60px;\n  }\n  .top-nav .navbar-nav.me-auto.mb-2.mb-lg-0 {\n    max-width: 300px;\n    margin: 30px auto 30px auto;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n  .nav-ul {\n    flex-wrap: wrap;\n    display: flex;\n    width: 100%;\n  }\n  .nav-ul li {\n    width: 100%;\n    margin: 0 0 15px 0;\n  }\n  .top-nav .d-flex.form-cus-nav {\n    flex-wrap: wrap;\n    max-width: 300px;\n    margin: auto;\n  }\n  .top-nav .areax-img {\n    margin: auto;\n  }\n  .right-side-img {\n    padding: 0;\n  }\n  .right-project {\n    padding: 0 0px 0 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .project-p-1,\n  .yellow-p,\n  .vec-p,\n  .join-p,\n  .contact-footer {\n    font-size: 23px;\n    line-height: 38px;\n  }\n  .project-p-2,\n  .under-flex ul li p,\n  .vec-p-1 {\n    font-size: 16px;\n    line-height: 26.5px;\n  }\n  .under-flex ul {\n    flex-wrap: wrap;\n  }\n  .under-flex ul li p {\n    margin: 0 0 15px 0;\n  }\n  .join-under li:nth-child(2) {\n    width: 100%;\n    margin: 0 0 15px 0;\n  }\n  .join-under li:nth-child(3) {\n    width: 100%;\n  }\n  .logo-under ul li img {\n    max-height: fit-content;\n    width: 100%;\n    height: auto;\n  }\n  .logo-under ul li {\n    width: 28%;\n    margin: 20px 0 0 0;\n  }\n  .footer-ul-1 li {\n    width: 100%;\n    margin: 0 0 30px 0;\n  }\n  .footer-ul-1 li:nth-child(3):after {\n    display: none;\n  }\n  .footer-label {\n    margin: 0 0 0px 0;\n  }\n  .footer-ul-2 li:nth-child(1) {\n    max-width: 100%;\n    margin: 0 0 30px 0;\n  }\n  .footer-ul-2 li {\n    width: 100%;\n  }\n  .footer-ul-2 li button {\n    width: 100%;\n  }\n  .footer-ul-3 {\n    margin: 15px 0 0 0;\n  }\n  .footer-ul-3 li a {\n    margin: 0 15px 0 0;\n    font-size: 18px;\n    line-height: 28.75px;\n  }\n  .top-nav nav.navbar.navbar-expand-lg.bg-body-tertiary {\n    padding: 30px 0 0px 0;\n  }\n  .PROJECTW {\n    padding: 30px 0 22px 0;\n  }\n  .logo-section {\n    padding: 0 0 40px 0;\n  }\n  .logo-under {\n    padding: 20px 0 0 0;\n  }\n  .project-p-size {\n    font-size: 30px;\n    line-height: normal;\n  }\n  .logo-under ul li:last-child {\n    bottom: 5px;\n  }\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
